module.exports = __webpack_public_path__ + "media/games.ef9b1b6f.mp3";